import React, { memo } from "react";
import { MenuItem, Select } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useLocalizedMessage } from "util/useLocalizedMessage";
import styles from "./DescriptionParametersSection.module.scss";

const menuItemClasses = { root: styles.quickUseMenuItem, selected: styles.quickUseMenuItemSelected };
const listItemClasses = { focusVisible: styles.quickUseMenuItemFocused };

function DescriptionParameterCandidateRow({ item, title, role, disabled, onReview, onRoleChange }) {
  const t = useLocalizedMessage();
  const tr = (key, values) => t(`descriptionParameters.${key}`, values);
  const statusClass = !role ? styles.statusPending : role === "ignore" ? styles.statusIgnored : role === "identifier" ? styles.statusSearch : styles.statusActive;
  return (
    <div
      className={styles.candidateRow}
      data-testid="description-candidate-row"
      data-field-label={item.label}
    >
      <button
        type="button"
        className={styles.rowButton}
        disabled={disabled}
        aria-label={tr("reviewField", {
          label: item.label
        })}
        onClick={() => onReview(item)}
      />
      <div className={styles.rowLayout}>
        <span className={styles.fieldIdentity}>
          <span className={styles.fieldCopy}>
            <strong>{title}</strong>
            {title !== item.label && <small>{item.label}</small>}
          </span>
        </span>
        <span className={styles.examples}>
          {(item.examples || [])
            .slice(0, 2)
            .map((value, index) => (
              <span
                className={styles.example}
                key={`${item.field_id}-${index}`}
              >
                {value}
              </span>
            ))}
        </span>
        <span className={styles.metric}>
          <strong>{item.product_count}</strong>
          <small>{tr("products")}</small>
        </span>
        <span className={styles.metric}>
          <strong>{item.distinct_value_count}</strong>
          <small>{tr("observedValues")}</small>
        </span>
        <label
          className={`${styles.quickUse} ${statusClass}`}
        >
          <Select
            disableUnderline
            displayEmpty
            IconComponent={ExpandMoreIcon}
            className={styles.quickUseSelect}
            classes={{
              select: styles.quickUseDisplay,
              icon: styles.quickUseIcon
            }}
            SelectDisplayProps={{
              "aria-label": tr("quickUse", {
                label: item.label
              })
            }}
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left"
              },
              classes: { paper: styles.quickUseMenu },
              MenuListProps: { className: styles.quickUseMenuList }
            }}
            value={role}
            disabled={disabled}
            onChange={event =>
              onRoleChange(item, event.target.value)
            }
          >
            <MenuItem value="" disabled classes={menuItemClasses} ListItemClasses={listItemClasses}>
              {tr("needsReview")}
            </MenuItem>
            <MenuItem value="parameter" classes={menuItemClasses} ListItemClasses={listItemClasses}>
              {tr("filterRole")}
            </MenuItem>
            <MenuItem value="identifier" classes={menuItemClasses} ListItemClasses={listItemClasses}>
              {tr("searchable")}
            </MenuItem>
            <MenuItem value="ignore" classes={menuItemClasses} ListItemClasses={listItemClasses}>
              {tr("ignore")}
            </MenuItem>
          </Select>
        </label>
        <span
          className={styles.editIcon}
          aria-hidden="true"
        >
          <EditOutlinedIcon />
        </span>
      </div>
    </div>
  );
}

export default memo(DescriptionParameterCandidateRow);
